import { c as _c } from "react-compiler-runtime";
import { PublicPageLayout } from './PublicPageLayout';
import { PublicMeetingDetails } from './PublicMeetingDetails';
import { PublicSenderNotes } from './PublicSenderNotes';
import { PublicRecordingCard } from './PublicRecordingCard';
import { PublicRecapCard } from './PublicRecapCard';
import { PublicTranscriptCard } from './PublicTranscriptCard';
import { MeetingDetailsSkeleton, RecordingCardSkeleton, RecapCardSkeleton } from './CardSkeletons';
import { ShareableAsset } from '../types/ExternalShareTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EMPTY_TRANSCRIPT = {
  utterances: [],
  participants: []
};
export const PublicShareView = t0 => {
  var _recordingCard, _recapCard;
  const $ = _c(32);
  const {
    selectedAssets,
    meetingDetails,
    senderNotes,
    recording,
    transcript,
    recapHtml
  } = t0;
  let t1;
  if ($[0] !== selectedAssets) {
    t1 = selectedAssets.has(ShareableAsset.VIDEO_RECORDING);
    $[0] = selectedAssets;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasVideo = t1;
  let t2;
  if ($[2] !== selectedAssets) {
    t2 = selectedAssets.has(ShareableAsset.AUDIO_RECORDING);
    $[2] = selectedAssets;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const hasAudio = t2;
  const hasRecording = hasVideo || hasAudio;
  let t3;
  if ($[4] !== selectedAssets) {
    t3 = selectedAssets.has(ShareableAsset.TRANSCRIPT);
    $[4] = selectedAssets;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const hasTranscript = t3;
  const hasAiSummary = selectedAssets.has(ShareableAsset.AI_SUMMARY);
  let recordingCard = null;
  if (hasRecording && recording) {
    const t4 = hasTranscript ? transcript !== null && transcript !== void 0 ? transcript : EMPTY_TRANSCRIPT : EMPTY_TRANSCRIPT;
    let t5;
    if ($[6] !== hasAudio || $[7] !== hasVideo || $[8] !== recording || $[9] !== t4) {
      t5 = /*#__PURE__*/_jsx(PublicRecordingCard, {
        recording: recording,
        transcript: t4,
        hasVideo: hasVideo,
        hasAudio: hasAudio
      });
      $[6] = hasAudio;
      $[7] = hasVideo;
      $[8] = recording;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    recordingCard = t5;
  } else {
    if (hasRecording) {
      let t4;
      if ($[11] !== hasVideo) {
        t4 = /*#__PURE__*/_jsx(RecordingCardSkeleton, {
          hasVideo: hasVideo
        });
        $[11] = hasVideo;
        $[12] = t4;
      } else {
        t4 = $[12];
      }
      recordingCard = t4;
    }
  }
  let t4;
  if ($[13] !== hasTranscript || $[14] !== recordingCard || $[15] !== transcript) {
    t4 = hasTranscript && !recordingCard && transcript && transcript.utterances.length > 0 ? /*#__PURE__*/_jsx(PublicTranscriptCard, {
      transcript: transcript
    }) : null;
    $[13] = hasTranscript;
    $[14] = recordingCard;
    $[15] = transcript;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const transcriptCard = t4;
  const mediaCard = (_recordingCard = recordingCard) !== null && _recordingCard !== void 0 ? _recordingCard : transcriptCard;
  let t5;
  if ($[17] !== meetingDetails) {
    t5 = meetingDetails ? /*#__PURE__*/_jsx(PublicMeetingDetails, {
      details: meetingDetails
    }) : /*#__PURE__*/_jsx(MeetingDetailsSkeleton, {});
    $[17] = meetingDetails;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const meetingDetailsCard = t5;
  let t6;
  if ($[19] !== senderNotes) {
    t6 = senderNotes ? /*#__PURE__*/_jsx(PublicSenderNotes, {
      notes: senderNotes
    }) : null;
    $[19] = senderNotes;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const senderNotesCard = t6;
  let recapCard = null;
  if (hasAiSummary && recapHtml !== undefined) {
    let t7;
    if ($[21] !== recapHtml) {
      t7 = /*#__PURE__*/_jsx(PublicRecapCard, {
        recapHtml: recapHtml
      });
      $[21] = recapHtml;
      $[22] = t7;
    } else {
      t7 = $[22];
    }
    recapCard = t7;
  } else {
    if (hasAiSummary) {
      let t7;
      if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/_jsx(RecapCardSkeleton, {});
        $[23] = t7;
      } else {
        t7 = $[23];
      }
      recapCard = t7;
    }
  }
  let t7;
  if ($[24] !== mediaCard || $[25] !== meetingDetailsCard || $[26] !== recapCard || $[27] !== senderNotesCard) {
    t7 = recapCard ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [mediaCard, meetingDetailsCard, senderNotesCard]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [meetingDetailsCard, senderNotesCard]
    });
    $[24] = mediaCard;
    $[25] = meetingDetailsCard;
    $[26] = recapCard;
    $[27] = senderNotesCard;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  const left = t7;
  const right = (_recapCard = recapCard) !== null && _recapCard !== void 0 ? _recapCard : mediaCard;
  let t8;
  if ($[29] !== left || $[30] !== right) {
    t8 = /*#__PURE__*/_jsx(PublicPageLayout, {
      left: left,
      right: right
    });
    $[29] = left;
    $[30] = right;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  return t8;
};